import React from 'react';
import { MasterDashboard } from '../../components/MasterDashboard/MasterDashboard';
import { useAuth } from '../../contexts/AuthContext';
import './style.css';

const SalonHomePage: React.FC = () => {
  const { user } = useAuth();

  console.log('🏠 SalonHomePage rendered - user:', user);
  console.log('🏠 SalonHomePage rendered - user role:', user?.role);
  console.log('🏠 SalonHomePage rendered - timestamp:', new Date().toISOString());

  // Get master ID from user context
  const masterId = user?.id || 'default-master-id';

  console.log('🏠 SalonHomePage - masterId:', masterId);

  if (!user) {
    console.log('🏠 SalonHomePage - No user found, showing loading...');
    return <div>Loading user data...</div>;
  }

  if (user.role !== 'master' && user.role !== 'owner' && user.role !== 'super_admin') {
    console.log('🏠 SalonHomePage - User role not authorized:', user.role);
    return <div>Access denied. Role: {user.role}</div>;
  }

  return (
    <div className="salon-home-page">
      <MasterDashboard 
        key={`dashboard-${user?.id}-${Date.now()}`} // Force re-render on user change
        masterId={masterId}
      />
    </div>
  );
};

export default SalonHomePage;